export default class bullet_screen {
  constructor(...props) {
    this.bullet_screen_box = document.createElement(`div`)
    this.propsBbj = props
    this.timer = null
    this.bullet_screen = `
            @keyframes bullet_screen {
                0% { 
                    opacity: 0;
                } 
                50% {
                    opacity: 1;
                }
                100% { 
                    opacity: 0;
                }
            }
        `
    this.style = document.createElement('style')
    this.style.type = 'text/css'
    this.style.innerHTML = this.bullet_screen
    this.maxX = 0
    this.maxY = 0
    document.getElementsByTagName('head')[0].appendChild(this.style)
  }
  createEl(el) {
    this.bullet_screen_box.style.width = 'auto'
    this.bullet_screen_box.style.height = 'auto'
    this.bullet_screen_box.style.boxSizing = 'border-box'
    this.bullet_screen_box.style.background = 'none'
    this.bullet_screen_box.style.position = 'absolute'
    this.sum()
    this.bullet_screen_box.style.color = this.propsBbj[1]
      ? this.propsBbj[1].color
      : '#000000'
    this.bullet_screen_box.style.fontSize = this.propsBbj[1]
      ? this.propsBbj[1].fontSize
      : '16px'
    this.bullet_screen_box.style.zIndex = 200
    this.bullet_screen_box.style.animation = `bullet_screen ${
      this.propsBbj[1] && this.propsBbj[1].time ? this.propsBbj[1].time : 5
    }s linear infinite`
    this.bullet_screen_box.style.transform = 'translateZ(100px)'
    this.bullet_screen_box.innerHTML = this.propsBbj[0]
    this.bullet_screen_box.setAttribute('id', 'bullet_screen')
    let prismPlayer = document.querySelector('.prism-player')
    this.maxX = parseInt(window.getComputedStyle(prismPlayer).width)
    this.maxY = parseInt(window.getComputedStyle(prismPlayer).height)
    prismPlayer.appendChild(this.bullet_screen_box)
    let video = el.getElementsByTagName('video')[0]
    video.addEventListener('play', () => this.bullet_play(), false)
    video.addEventListener('pause', () => this.clear_bullet(), false)
    video.addEventListener('ended', () => this.clear_bullet(), false)
  }
  timeupdate() {}
  sum() {
    let random = Math.random()
    random = random < 0.2 ? 0.2 : random > 0.8 ? 0.8 : random
    let x = Math.floor(random * this.maxX)
    let y = Math.floor(random * this.maxY)
    let left = x > 0 ? `${x}px` : '50%',
      top = y > 0 ? `${y}px` : '50%'
    this.bullet_screen_box.style.left = left
    this.bullet_screen_box.style.top = top
  }
  bullet_play() {
    this.timer = setInterval(() => this.sum(), 10000)
  }
  clear_bullet() {
    clearInterval(this.timer)
    this.timer = null
  }
}
